import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import DescriptionCardWithLogo from "./DescriptionCardWithLogo";
import Image from "@shared/components/contents/image/Image";
const DescriptionCardWithLogoPreview = () => {
    return (_jsx(DescriptionCardWithLogo, { logo: _jsx(Image, { file: { url: "/exemple-image.jpg" }, disableLazy: true }), title: "Titre", description: "Zone avec la description" }));
};
export default DescriptionCardWithLogoPreview;
